import React from 'react';
import Helmet from 'react-helmet';

const MetaHeader = ({ name, happiness, total_ratings, logo }) =>
  <Helmet
    title={`${name ? name : ''} Customer Service Quality Page`}
    meta={[
      { name: 'robots', content: 'index,follow' },
      {
        name: 'description',
        content: `Check Customer Happiness Rate, Total Number of Ratings and Average Response Time at ${name
          ? name
          : window.location.href}`
      },
      {
        name: 'og:image',
        content: 'https://cdn.livechatinc.com/qb/quality-badge-share@2x.png'
      }
    ]}
    script={[
      {
        type: 'application/ld+json',
        innerHTML: `{
                  "@context": "http://schema.org/",
                  "@type": "LocalBusiness",
                  "name": "${name ? name : 'Customer Service'}",
                  "image": "https://${logo}",
                  "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "${happiness === '0' ? happiness : 86}",
                    "bestRating": "100",
                    "ratingCount": "${total_ratings}"
                  }
                }`
      }
    ]}
  />;

export default MetaHeader;
